import * as constants from './constants';

export function setSubscriptionAccountList(accounts) {
  return {
    type: constants.SET_SUBSCRIPTION_ACCOUNT_LIST,
    accounts,
  };
}

export function setSubscriptionTeamList(teams) {
  return {
    type: constants.SET_SUBSCRIPTION_TEAM_LIST,
    teams,
  };
}
